import { render, staticRenderFns } from "./TemplateLetterFree.vue?vue&type=template&id=2d80b2a6"
import script from "./TemplateLetterFree.vue?vue&type=script&lang=js"
export * from "./TemplateLetterFree.vue?vue&type=script&lang=js"
import style0 from "./TemplateLetterFree.vue?vue&type=style&index=0&id=2d80b2a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports